import script from "./ElementLayout.vue?vue&type=script&lang=js"
export * from "./ElementLayout.vue?vue&type=script&lang=js"

import "./ElementLayout.vue?vue&type=style&index=0&id=0510af81&lang=scss"

const __exports__ = script;

export default __exports__